import date from "@common/lib/date";
import { type I18n, i18nFormat } from "@common/lib/i18n";
import moment from "moment";
import "moment-duration-format";
import { type Courses } from "../../types";

export const getAttemptsLeftMessage = (i18n: I18n, lesson: Courses.CourseLessonAppState): string | null =>
  lesson.lesson.reattempts
    ? i18nFormat(
        i18n.infoProgramModuleLessonAttemptsLeft,
        ["M", Math.max(lesson.lesson.reattempts - (lesson.quizState?.attempts ?? 0), 0)],
        ["N", lesson.lesson.reattempts]
      )
    : null;

export const getDelayMessage = (i18n: I18n, lesson: Courses.CourseLessonAppState): string | null =>
  lesson.lesson.reattemptDelay
    ? i18nFormat(i18n.infoProgramModuleLessonDelayBetweenAttempts, [
        "DELAY",
        moment.duration(lesson.lesson.reattemptDelay, lesson.lesson.reattemptDelayTimeUnitKey as any).format()
      ])
    : null;

export const getNextAttemptTooltip = (i18n: I18n, nextAttemptOnDate: string | null): string | undefined => {
  if (!nextAttemptOnDate || moment(nextAttemptOnDate) < moment()) return;
  if (moment(nextAttemptOnDate) > moment().add(5, "years")) return i18n.infoQuizNumberOfAttemptsExceeded;

  return i18nFormat(i18n.infoQuizNextAttemptDate, ["DATE", date.formatDateTime(nextAttemptOnDate)]);
};
